/** Catalog additions without published analytical batch documentation. */
const PRODUCTS_WITHOUT_DOCUMENTED_QUALITY_CLAIMS = new Set([
	"semaglutide",
	"b12",
	"aod-9604",
	"cjc-1295-dac",
	"snap-8",
	"kisspeptin-10",
]);

export function hasDocumentedProductQualityClaims(slug?: string): boolean {
	return !slug || !PRODUCTS_WITHOUT_DOCUMENTED_QUALITY_CLAIMS.has(slug);
}
